import { render, staticRenderFns } from "./CapturaDocumentosFotoFrente.vue?vue&type=template&id=12cb3220&scoped=true&"
import script from "./CapturaDocumentosFotoFrente.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentosFotoFrente.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentosFotoFrente.vue?vue&type=style&index=0&id=12cb3220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cb3220",
  null
  
)

export default component.exports